import { Contact } from "../sections/Contact";

export default function ContactPage() {
  return <Contact />;
}
